import React from 'react';

/**
 * FeatureBadge - A reusable pill badge for "New", "Beta", or custom tags.
 *
 * @param {'new' | 'beta'} variant - Badge style variant ('new' or 'beta'). Defaults to 'new'.
 * @param {string} label - Custom text label. Defaults to 'NEW' or 'BETA' based on variant.
 * @param {'sm' | 'md'} size - Size variant ('sm' | 'md'). Defaults to 'sm'.
 * @param {string} className - Additional CSS classes.
 */
const FeatureBadge = ({
  variant = 'new',
  label,
  size = 'sm',
  className = '',
}) => {
  const isBeta = variant?.toLowerCase() === 'beta';

  const badgeText = label || (isBeta ? 'BETA' : 'NEW');

  const variantStyles = isBeta
    ? 'bg-purple-50 text-aimhi-hero border border-purple-200'
    : 'bg-emerald-50 text-aimhi-primary border border-emerald-200';

  const sizeStyles =
    size === 'md'
      ? 'text-xs px-2.5 py-0.5'
      : 'text-[10px] px-2 py-0.5 tracking-wider';

  return (
    <span
      className={`inline-flex items-center justify-center font-bold uppercase rounded-full select-none ${variantStyles} ${sizeStyles} ${className}`.trim()}
    >
      {badgeText}
    </span>
  );
};

export default FeatureBadge;

